import React from "react";
import {
  EyeOutlined,
  FileExcelOutlined,
  SearchOutlined,
  FolderOpenOutlined,
  BankOutlined,
  FileProtectOutlined,
  FileDoneOutlined,
  CalendarOutlined,
  HomeOutlined,
  CalculatorOutlined,
  ContainerOutlined,
  BarcodeOutlined,
  FileTextOutlined,
  FileSearchOutlined,
  UnorderedListOutlined,
  HistoryOutlined,
  TransactionOutlined,
  DollarOutlined,
  BarChartOutlined,
  RetweetOutlined,
  CarOutlined,
  ShoppingCartOutlined,
  RollbackOutlined,
  FolderViewOutlined,
  FileSyncOutlined,
  ThunderboltOutlined,
  AuditOutlined,
  BookOutlined,
} from "@ant-design/icons";

// โครงสร้างเมนูแบบแบ่งกลุ่ม ใช้ร่วมกันระหว่าง MenuDashboard และ Sidenav
// สิทธิ์การมองเห็นกำหนดผ่าน show ของแต่ละกลุ่ม/เมนู
export const getMenuGroups = () => {
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const userId = localStorage.getItem("USER_ID");

  return [
    {
      groupTitle: "ข้อมูลสัญญา",
      groupIcon: <BookOutlined />,
      show: true,
      // ROLE_ID === "1" ||
      // ROLE_ID === "2" ||
      // ROLE_ID === "3" ||
      // ROLE_ID === "4" ||
      // ROLE_ID === "5" ||
      // ROLE_ID === "6" ||
      // ROLE_ID === "12" ||
      // ROLE_ID === "13",
      items: [
        {
          icon: <ContainerOutlined />,
          label: "รายละเอียดสัญญา",
          path: "/search/contarct-detail",
          show: true,
        },
        {
          icon: <ContainerOutlined />,
          label: "ค้นหาสัญญาใหม่",
          path: "/search/contarct-detail-new",
          show: true,
        },
        {
          icon: <ContainerOutlined />,
          label: "การ์ดลูกหนี้",
          path: "/contract-detail/detail-payment",
          show: ROLE_ID !== "5",
        },
        {
          icon: <FileTextOutlined />,
          label: "สัญญาทั้งหมด",
          path: "/main-all-contract",
          show: ROLE_ID === "1" || ROLE_ID === "2" || ROLE_ID === "3",
        },
        // {
        //   icon: <FileTextOutlined />,
        //   label: `รายงานค้างงวด (ตามงวด)`,
        //   path: "/lost-contact-debts",
        //   show: ROLE_ID === "1" || ROLE_ID === "2",
        // },
        {
          icon: <FileTextOutlined />,
          label: `รายงานทรัพย์พิพากษา`,
          path: "/load-judge-assets",
          show: ROLE_ID === "1" || ROLE_ID === "2",
        },
        {
          icon: <ContainerOutlined />,
          label: "รายละเอียดสัญญา version เก่า",
          path: "/search/contarct-old-version",
          show: ROLE_ID === "1",
        },
      ],
    },
    {
      groupTitle: "ผู้บริหาร",
      groupIcon: <EyeOutlined />,
      show: ROLE_ID === "1" || ROLE_ID === "5",
      subGroups: [
        {
          subTitle: "การจัดการ",
          items: [
            {
              icon: <EyeOutlined />,
              label: "จัดการสัญญา",
              path: "/manage-contract/choose-contract",
              show: ROLE_ID === "1" || ROLE_ID === "5",
            },
            {
              icon: <FileDoneOutlined />,
              label: "ตรวจข้อมูลอุธรณ์",
              path: "/manage-contract/ceo-recheck-judgement",
              show: true,
            },
          ],
        },
        {
          subTitle: "รายงาน",
          items: [
            {
              icon: <UnorderedListOutlined />,
              label: "รายงานการรับชำระ",
              path: "/menu-manage-finance/report-payment",
              show: true,
            },
            {
              icon: <FileSearchOutlined />,
              label: "รายงานเงินทดรอง",
              path: "/menu-manage-advance-payment/report-advance-payment",
              show: true,
            },
            {
              icon: <DollarOutlined />,
              label: "รายงานการขายผ่อน",
              path: "/menu-acc/report-selling",
              show: true,
            },
            {
              icon: <DollarOutlined />,
              label: "รายงานการขาย(ขายสด,ผ่อน)",
              path: "/menu-acc/report-selling-and-installments",
              show: true,
            },
            {
              icon: <DollarOutlined />,
              label: "รายงานลูกหนี้คงเหลือ",
              path: "/menu-acc/report-debtors",
              show: true,
            },

            {
              icon: <CalendarOutlined />,
              label: "วันนัดศาล",
              path: "/lawsuit/appointment-court",
              show: true,
            },
            {
              icon: <DollarOutlined />,
              label: "รายงานรับรู้กำไร",
              path: "/menu-acc/report-profit-recognition",
              show: true,
            },
            {
              icon: <BarChartOutlined />,
              label: "สรุปงานทนาย",
              path: "/manage-contract/dashborad-lawyer-job",
              show: true,
            },
            {
              icon: <BarChartOutlined />,
              label: "สรุปงานทนาย(รับชำระ)",
              path: "/manage-contract/dashborad-lawyer-job-receiv",
              show: true,
            },
            {
              icon: <FileDoneOutlined />,
              label: "รายงานการยึด",
              path: "/report-lawyers-enforce",
              show: true,
            },
          ],
        },
      ],
    },
    {
      groupTitle: "ธุรการ/ทะเบียน",
      groupIcon: <FileProtectOutlined />,
      show: ROLE_ID === "1" || ROLE_ID === "11",
      items: [
        {
          icon: <FileProtectOutlined />,
          label: "เอกสารสัญญา",
          path: "/document-contno/check-document-contno",
          show: ROLE_ID === "1" || ROLE_ID === "11",
        },
        {
          icon: <ShoppingCartOutlined />,
          label: "ขายรถยึด",
          path: "/document-contno/selling-car-impound",
          show: true,
        },
      ],
    },
    {
      groupTitle: "ธุรการกฎหมาย",
      groupIcon: <SearchOutlined />,
      show: ROLE_ID === "1" || ROLE_ID === "2",
      subGroups: [
        {
          subTitle: "การจัดการสัญญา",
          items: [
            // {
            //   icon: <FileExcelOutlined />,
            //   label: "บอกเลิกสัญญา",
            //   path: "/menu-cancel-contrat",
            //   // show: ROLE_ID === "1" || ROLE_ID === "2" || ROLE_ID === "5",
            //   show: false,
            // },
            {
              icon: <FileExcelOutlined />,
              label: "บอกเลิกสัญญา(มือ)",
              path: "/menu-cancel-contrat-hand",
              // show: ROLE_ID === "1" || ROLE_ID === "2" || ROLE_ID === "5",
              show: false,
            },
            {
              icon: <EyeOutlined />,
              label: "จัดการสัญญา",
              path: "/manage-contract/choose-contract",
              show: true,
            },
            {
              icon: <EyeOutlined />,
              label: "จัดการสัญญา(เก่า)",
              path: "/manage-contract-old/choose-contract-old",
              show: true,
            },
            {
              icon: <SearchOutlined />,
              label: "สืบก่อนฟ้อง",
              path: "/menu-pre-investigate-assets",
              show: ROLE_ID === "1" || ROLE_ID === "2" || ROLE_ID === "5",
            },
            {
              icon: <RetweetOutlined />,
              label: "เปลี่ยนผู้รับผิดชอบ(ฟ้อง)",
              path: "/manage-contract/change-lawyer-jobs",
              show: true,
            },
            {
              icon: <RollbackOutlined />,
              label: "คืนงานทนาย",
              path: "/manage-contract/rollback-jobs-lawyers",
              show: true,
            },
          ],
        },
        {
          subTitle: "งานเตรียมฟ้อง/ชั้นศาล",
          items: [
            {
              icon: <FileDoneOutlined />,
              label: "เตรียมเอกสารส่งฟ้อง",
              path: "/pre-investigate-assets/check-document",
              show: true,
            },
            {
              icon: <FileDoneOutlined />,
              label: "ตรวจคำพิพากษา",
              path: "/after-court/recheck-judgement",
              show: true,
            },
            {
              icon: <AuditOutlined />,
              label: "ใบปะหน้าพิพากษา",
              path: "/court/enforce-case-doc",
              show: true,
            },
            {
              icon: <BarChartOutlined />,
              label: "สรุปงานทนาย",
              path: "/manage-contract/dashborad-lawyer-job",
              show: true,
            },
            {
              icon: <FileTextOutlined />,
              label: "เอกสาร AMC",
              path: "/main-doc-amc",
              show: true,
            },
            {
              icon: <FileTextOutlined />,
              label: "เอกสาร AMC V.2",
              path: "/main-doc-amc-v2",
              show: true,
            },
          ],
        },
        {
          subTitle: "งานบังคับคดี",
          items: [
            // {
            //   icon: <FolderViewOutlined />,
            //   label: "ขาดการติดต่อ(พิพากษา)",
            //   path: "/enforce-investigate/enforce-investigate/select-contract-to-pre-enforce",
            //   show: ROLE_ID === "1",
            // },
            {
              icon: <FolderViewOutlined />,
              label: "สัญญารอส่งบังคับคดี",
              path: "/enforce-investigate/enforce-investigate/select-contract-to-enforce",
              show: ROLE_ID === "1" || ROLE_ID === "2",
            },
            {
              icon: <FolderViewOutlined />,
              label: "สัญญาที่ถูกมอบหมาย",
              path: "/enforce-investigate/enforce-investigate/contract-to-enforce",
              show: ROLE_ID === "1" || ROLE_ID === "2",
            },
            // {
            //   icon: <FolderViewOutlined />,
            //   label: "แจกงานสืบลงพื้นที่",
            //   path: "/enforce-investigate/main-assign-investigator-onsite-judge",
            //   show: ROLE_ID === "1",
            // },
            // {
            //   icon: <FolderViewOutlined />,
            //   label: "แจกงานสืบลงพื้นที่มีดิว",
            //   path: "/enforce-investigate/assign-investigate-onsite",
            //   show: ROLE_ID === "1",
            // },
            {
              icon: <FileSyncOutlined />,
              label: "โยกงานสืบทรัพย์",
              path: "/enforce-investigate/main-change-investor",
              show: true,
            },
            {
              icon: <FileSyncOutlined />,
              label: "ขอรีไฟแนนซ์",
              path: "/menu-refinance",
              show: true,
            },
            // {
            //   icon: <FileSyncOutlined />,
            //   label: "ตามเอกสารคำบังคับ",
            //   path: "/enforce-investigate/main-change-investor",
            //   show: true,
            // },
            // {
            //   icon: <FundProjectionScreenOutlined />,
            //   label: "รายงานการสืบทรัพย์ลงพื้นที่",
            //   path: null,
            //   show: ROLE_ID === "1",
            // },
          ],
        },
      ],
    },
    {
      groupTitle: "ธุรการกฎหมาย(ใหม่)",
      groupIcon: <FileExcelOutlined />,
      show: ROLE_ID === "1" || ROLE_ID === "2" || ROLE_ID === "13",
      items: [
        {
          icon: <FileExcelOutlined />,
          label: "ออกบอกเลิกสัญญา",
          path: "/menu-work-cancel-contrat",
          show: true,
        },
        {
          icon: <FileExcelOutlined />,
          label: "ออกบอกกล่าว",
          path: "/demand-guarantor/create-demand-guarantor",
          show: true,
        },
        {
          icon: <FileExcelOutlined />,
          label: "ตรวจสอบไปรษณีย์",
          path: "/letter-calendar/main",
          show: true,
        },
        {
          icon: <FileExcelOutlined />,
          label: "ออกจดหมายตามรอบ12/26",
          path: "/demand-guarantor/SentCEO",
          show: true,
        },
      ],
    },
    {
      groupTitle: "งานกฎหมาย",
      groupIcon: <FolderOpenOutlined />,
      show: ROLE_ID === "1" || ROLE_ID === "3",
      subGroups: [
        {
          subTitle: "การจัดการ",
          items: [
            {
              icon: <FolderOpenOutlined />,
              label: "คำฟ้อง",
              path: "/menu-lawsuit",
              show: ROLE_ID === "1" || ROLE_ID === "3",
            },
            {
              icon: <BankOutlined />,
              label: "ชั้นศาล",
              path: "/menu-court",
              show: ROLE_ID === "1" || ROLE_ID === "3",
            },
            {
              icon: <ThunderboltOutlined />,
              label: "ชั้นบังคับคดี",
              path: "/menu-enforce",
              show: ROLE_ID === "1" || ROLE_ID === "3",
            },
          ],
        },
        {
          subTitle: "รายงาน",
          items: [
            {
              icon: <CalendarOutlined />,
              label: "วันนัดศาล",
              path: "/lawsuit/appointment-court",
              show:
                ROLE_ID === "1" ||
                ROLE_ID === "3" ||
                ROLE_ID === "2" ||
                ROLE_ID === "5",
            },
            {
              icon: <BarChartOutlined />,
              label: "สรุปงานทนาย",
              path: "/manage-contract/dashborad-lawyer-job",
              show: true,
            },
            {
              icon: <FileTextOutlined />,
              label: "เอกสาร AMC",
              path: "/main-doc-amc",
              show: true,
            },
            {
              icon: <FileTextOutlined />,
              label: "เอกสาร AMC V.2",
              path: "/main-doc-amc-v2",
              show: true,
            },
          ],
        },
      ],
    },
    {
      groupTitle: "การเงิน",
      groupIcon: <DollarOutlined />,
      show:
        ROLE_ID === "1" ||
        ROLE_ID === "6" ||
        userId === "4" ||
        ROLE_ID === "14" ||
        ROLE_ID === "10" ||
        userId === "47",
      // เปลี่ยนจาก items เป็น subGroups
      subGroups: [
        {
          subTitle: "การจัดการ",
          items: [
            {
              icon: <FileProtectOutlined />,
              label: "เงินทดรองจ่าย(ฟ้อง)(ใหม่)",
              path: "/menu-manage-advance-payment/lawsuit",
              show: ROLE_ID === "1" || ROLE_ID === "6" || ROLE_ID === "14",
            },
            {
              icon: <HomeOutlined />,
              label: "เงินทดรองจ่าย(เก่า)",
              path: "/menu-manage-advance-payment/legal-execution",
              show: ROLE_ID === "1" || ROLE_ID === "14" || userId === "4",
            },
            {
              icon: <FileDoneOutlined />,
              label: "ตั้งจ่ายเงินสืบทรัพย์",
              path: "/menu-manage-finance/main-investigate-payment",
              show: ROLE_ID === "1" || ROLE_ID === "14",
            },
            {
              icon: <CalculatorOutlined />,
              label: "ขอยอดปิด",
              path: "/finance/closing-balance/request-closing-balance",
              show:
                ROLE_ID === "1" ||
                ROLE_ID === "14" ||
                ROLE_ID === "10" ||
                userId === "47",
            },
            {
              icon: <TransactionOutlined />,
              label: "ตัดจ่าย (1,8)",
              path: "/menu-manage-finance/finance-cut-pay",
              show: ROLE_ID === "1" || ROLE_ID === "6",
            },
            {
              icon: <TransactionOutlined />,
              label: "รับชำระ",
              path: "/menu-manage-finance/menu-receive-payment",
              show: ROLE_ID === "1" || ROLE_ID === "6",
            },
            {
              icon: <ShoppingCartOutlined />,
              label: "ขายรถยึด",
              path: "/document-contno/selling-car-impound",
              show: ROLE_ID === "1" || ROLE_ID === "6",
            },
          ],
        },
        {
          subTitle: "รายงาน",
          items: [
            {
              icon: <UnorderedListOutlined />,
              label: "รายงานการรับชำระ",
              path: "/menu-manage-finance/report-payment",
              show: ROLE_ID === "1" || ROLE_ID === "6",
            },
            {
              icon: <FileSearchOutlined />,
              label: "รายงานเงินทดรอง",
              path: "/menu-manage-advance-payment/report-advance-payment",
              show: ROLE_ID === "1" || ROLE_ID === "6",
            },
          ],
        },
      ],
    },
    {
      groupTitle: "บัญชี",
      groupIcon: <CalculatorOutlined />,
      show: ROLE_ID === "1" || ROLE_ID === "12",
      subGroups: [
        {
          subTitle: "การจัดการ",
          items: [
            {
              icon: <BarcodeOutlined />,
              label: "ตั้งจ่ายเงินสืบทรัพย์",
              path: "/menu-acc/create-investigate-payment",
              show: true,
            },
            {
              icon: <FileDoneOutlined />,
              label: "ตรวจรายละเอียดการขาย",
              path: "/menu-acc/acc-recheck-judgement",
              show: true,
            },
            {
              icon: <HistoryOutlined />,
              label: "post GL",
              path: "/menu-acc/post-gl",
              show: true,
            },
            {
              icon: <CarOutlined />,
              label: "ขายทอดตลาด",
              path: "/document-contno/selling-car-impound",
              show: true,
            },
            {
              icon: <TransactionOutlined />,
              label: "อนุมัติเคลียร์(ใหม่)",
              path: "/finance/advance-payment-lawsuit/aprove-clear-advance-payment",
              show:
                ROLE_ID === "1" ||
                ROLE_ID === "6" ||
                ROLE_ID === "14" ||
                ROLE_ID === "12",
            },
            {
              icon: <TransactionOutlined />,
              label: "อนุมัติเคลียร์(เก่า)",
              path: "/finance/charge-indict/clear-advane-pay",
              show: ROLE_ID === "1" || ROLE_ID === "14" || ROLE_ID === "12",
            },
          ],
        },
        {
          subTitle: "รายงาน",
          items: [
            {
              icon: <UnorderedListOutlined />,
              label: "การรับชำระรายสัญญา",
              path: "/menu-manage-finance/report-contno-receive-payment",
              show: true,
            },
            {
              icon: <UnorderedListOutlined />,
              label: "รายงานการรับชำระ",
              path: "/menu-manage-finance/report-payment",
              show: true,
            },
            {
              icon: <FileSearchOutlined />,
              label: "รายงานเงินทดรอง",
              path: "/menu-manage-advance-payment/report-advance-payment",
              show: true,
            },
            {
              icon: <DollarOutlined />,
              label: "รายงานการขายผ่อน",
              path: "/menu-acc/report-selling",
              show: true,
            },
            {
              icon: <DollarOutlined />,
              label: "รายงานการขาย(ขายสด,ผ่อน)",
              path: "/menu-acc/report-selling-and-installments",
              show: true,
            },
            {
              icon: <DollarOutlined />,
              label: "รายงานลูกหนี้คงเหลือ",
              path: "/menu-acc/report-debtors",
              show: true,
            },
            {
              icon: <CarOutlined />,
              label: "รายงานรถยึดรอไถ่ถอน",
              path: "/menu-acc/report-impound-car",
              show: true,
            },
            {
              icon: <CarOutlined />,
              label: "รายงานสินค้าคงเหลือ",
              path: "/menu-acc/report-pending-selling-car",
              show: true,
            },
            {
              icon: <ShoppingCartOutlined />,
              label: "รายงานรอขายทอดตลาด",
              path: "/menu-acc/report-selling-car",
              show: true,
            },
            {
              icon: <DollarOutlined />,
              label: "รายงานรับรู้กำไร",
              path: "/menu-acc/report-profit-recognition",
              show: true,
            },
            {
              icon: <FileDoneOutlined />,
              label: "รายงานผู้ตรวจสอบ",
              path: "/menu-acc/report-manager-acc",
              show: true,
            },

            {
              icon: <FileTextOutlined />,
              label: `รายงานตามงวด`,
              path: "/menu-acc/lost-contact-debts-acc",
              show: true,
            },
            {
              icon: <FileDoneOutlined />,
              label: "รายงานรับเข้า stock",
              path: "/document-contno/report-income-stock",
              show: true,
            },
          ],
        },
      ],
    },
    {
      groupTitle: "ส่วนบังคับคดี",
      groupIcon: <ThunderboltOutlined />,
      show: ROLE_ID === "1" || ROLE_ID === "3" || ROLE_ID === "4",
      subGroups: [
        {
          subTitle: "ลงพื้นที่สืบทรัพย์",
          items: [
            {
              icon: <FolderViewOutlined />,
              label: "สัญญาที่ถูกมอบหมาย",
              path: "/enforce-investigate/enforce-investigate/contract-to-enforce",
              show: ROLE_ID === "1" || ROLE_ID === "3" || ROLE_ID === "4",
            },

            // {
            //   icon: <UnorderedListOutlined />,
            //   label: "รับงานสืบทรัพย์",
            //   path: "/enforce-investigate/main-accept-jobs",
            //   show: ROLE_ID === "1",
            // },
            {
              icon: <FileSearchOutlined />,
              label: "เลือกสัญญาลงพื้นที่",
              path: "/enforce-investigate/main-select-location-investigagte",
              show: true,
            },
            {
              icon: <FileSearchOutlined />,
              label: "ข้อมูลการลงพื้นที่",
              path: "/enforce-investigate/main-investigate-route",
              show: ROLE_ID === "1",
            },
            {
              icon: <FileSearchOutlined />,
              label: "เบิกเงิดทดลองลงพื้นที่",
              path: "/enforce-investigate/withdraw-advance-payment-onsite",
              show: ROLE_ID === "1",
            },
            {
              icon: <FileSearchOutlined />,
              label: "เคลียร์เงิดทดลองลงพื้นที่",
              path: "/enforce-investigate/clear-advance-payment-onsite",
              show: ROLE_ID === "1",
            },
            {
              icon: <FileSearchOutlined />,
              label: "รายงานการสืบทรัพย์ลงพื้นที่",
              path: "/enforce/report-investigate-onsite",
              show: ROLE_ID === "1",
            },
          ],
        },

        // {
        //   subTitle: "บังคับคดี/ยึดทรัพย์",
        //   items: [
        //     {
        //       icon: <UnorderedListOutlined />,
        //       label: "เลือกสัญญาบังคับคดี",
        //       path: "/enforce-asset/main-select-enforce-asset",
        //       show: ROLE_ID === "1",
        //     },
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "เบิกเงินบังคับคดี",
        //       path: "/enforce-asset/withdraw-advance-payment-enforce-asset",
        //       show: ROLE_ID === "1",
        //     },
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "เคลียร์เงินบังคับคดี",
        //       path: "/enforce-asset/clear-advance-payment-enforce-asset",
        //       show: ROLE_ID === "1",
        //     },
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "รายงานการยึดทรัพย์",
        //       path: "/enforce-asset/report-enforce-asset",
        //       show: ROLE_ID === "1",
        //     },
        //   ],
        // },
        // {
        //   subTitle: "ประกาศขายทรัพย์",
        //   items: [
        //     {
        //       icon: <UnorderedListOutlined />,
        //       label: "เลือกสัญญาประกาศขาย",
        //       path: "/asset-announcement/main-select-asset-announcement",
        //       show: ROLE_ID === "1",
        //     },
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "วันนัดประมูลทรัพย์",
        //       path: "/asset-announcement/asset-announcement-calendar",
        //       show: ROLE_ID === "1",
        //     },
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "เบิกเงินวางประกันทรัพย์",
        //       path: "/asset-announcement/report-advance-payment",
        //       show: ROLE_ID === "1",
        //     },
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "เคลียร์เงินวางประกันทรัพย์",
        //       path: "/asset-announcement/report-advance-payment",
        //       show: ROLE_ID === "1",
        //     },
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "รายงานการขายทรัพย์",
        //       path: "/asset-announcement/report-advance-payment",
        //       show: ROLE_ID === "1",
        //     },
        //   ],
        // },
        // {
        //   subTitle: "ประมูลทรัพย์",
        //   items: [
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "เบิกเงินประมูลทรัพย์",
        //       path: "/asset-announcement/report-advance-payment",
        //       show: ROLE_ID === "1",
        //     },
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "เคลียร์เงินประมูลทรัพย์",
        //       path: "/asset-announcement/report-advance-payment",
        //       show: ROLE_ID === "1",
        //     },
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "รายงานการประมูล",
        //       path: "/asset-announcement/report-advance-payment",
        //       show: ROLE_ID === "1",
        //     },
        //   ],
        // },
        // {
        //   subTitle: "เฉลี่ยร์ทรัพย์",
        //   items: [
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "ขอเฉลี่ยร์ทรัพย์",
        //       path: "/asset-average/main-select-asset-average",
        //       show: ROLE_ID === "1",
        //     },
        //     {
        //       icon: <FileSearchOutlined />,
        //       label: "รายงานเฉลี่ยร์ทรัพย์",
        //       path: "/menu-manage-advance-payment/report-advance-payment",
        //       show: ROLE_ID === "1",
        //     },
        //   ],
        // },
      ],
    },
    {
      groupTitle: "ชุดนอก",
      groupIcon: <CarOutlined />,
      show: ROLE_ID === "1" || ROLE_ID === "2" || ROLE_ID === "15",
      subGroups: [
        {
          subTitle: "ลงพื้นที่",
          items: [
            {
              icon: <FolderViewOutlined />,
              label: "สัญญาติดตาม",
              path: "/main-field-collection/contract-to-field-collection",
              show: true,
            },
          ],
        },
      ],
    },
  ];
};
